import $ from "jquery";
import _ from "lodash";

import alert from "../alert";

/**
 * Generic forms module used for JS validation and submitting forms/handling responses via ajax.
 */
const form = {
  ERROR_LABEL_CLASS: "form-field-error",
  ERROR_FIELD_CLASS: "form-field--has-error",
  FORM_DIRTY_CLASS: "form--is-dirty", // ie, did user try to submit once already (ie, trigger inline messages)
  DEFAULT_ERROR_MESSAGE: "This field is required.",

  /**
   * Get JSON object containing required field errors.
   * @param  {object} $form
   */
  getRequiredFieldErrors($form) {
    const $required = $form.find('[name="required-field-errors"]');
    if (!$required.length) {
      return {};
    }
    return $.parseJSON($required.attr("data-value"));
  },

  /**
   * Check a form to see if required fields are filled in.
   * @param  {object}  $form
   * @return {Boolean}
   */
  hasRequiredFields($form) {
    const requiredFieldErrors = this.getRequiredFieldErrors($form);
    const self = this;
    const errors = [];
    $form.find('[data-required="true"]').each(function () {
      const $field = $(this);
      if (_.isEmpty($field.val())) {
        const fieldName = $field.attr("name");
        const errorMessage = requiredFieldErrors[fieldName];
        errors.push({
          fieldName,
          message: errorMessage || self.DEFAULT_ERROR_MESSAGE,
        });
      }
    });
    if (errors.length) {
      return errors;
    }
    return true;
  },

  /**
   * Show errors for a form
   *
   * @param  {object} $form
   * @param  {array} errors [{fieldName: string, message: string}]
   */
  showErrors($form, errors) {
    errors.forEach((error) => {
      this.showError($form.find(`[name="${error.fieldName}"]`), error.message);
    });

    // focus problem field
    const firstWithError = errors.shift();
    $form.find(`[name="${firstWithError.fieldName}"]`).focus();
  },

  /**
   * Hide field error
   * @param  {object} $field
   */
  hideError($field) {
    $field.removeClass(this.ERROR_FIELD_CLASS);
    $field.parent("li").find(`.${this.ERROR_LABEL_CLASS}`).hide();
  },

  /**
   * Show field level error
   * @param  {object} $field
   * @param  {string=} errorMessage - optional message
   */
  showError($field, errorMessage) {
    const $fieldParent = $field.parent("li");
    const $error = $fieldParent.find(`.${this.ERROR_LABEL_CLASS}`);

    $field.addClass(this.ERROR_FIELD_CLASS);
    if ($error.length) {
      $error.show();
    } else {
      $fieldParent.append(
        `<label class="${this.ERROR_LABEL_CLASS}">${errorMessage}` ||
          `${this.DEFAULT_ERROR_MESSAGE}</label>`
      );
    }
  },

  /**
   * Validate form
   *
   * @param  {object} $form
   */
  validate($form) {
    $form.addClass(this.FORM_DIRTY_CLASS);
    const validOrErrors = this.hasRequiredFields($form);
    if (validOrErrors === true) {
      this.submit($form);
    } else {
      this.showErrors($form, validOrErrors);
    }
  },

  /**
   * Submit form via ajax
   *
   * @param {object} $form
   */
  submit($form) {
    const self = this;
    $.ajax({
      data: $form.serialize(),
      url: $form.attr("data-ajax-action"),
      method: $form.attr("method"),
      headers: {
        "X-CSRF-Token": $form.find('[name="csrf-token"]').attr("data-value"),
      },
      success(json) {
        const data = $.parseJSON(json);
        const alertType =
          data.status === true ? alert.TYPE_SUCCESS : alert.TYPE_ERROR;
        alert.show(data.message, alertType);
        if (data.status === true) {
          self.clearFields($form);
        }
      },
      error() {
        alert.show("Unable to process form.", alert.TYPE_ERROR);
      },
    });
  },

  /**
   * Clear form fields. Only wired for what's in use now; add the other
   * field types as needed.
   *
   * @param  {object} $form
   */
  clearFields($form) {
    $form.find(".form-field").each(function () {
      const $this = $(this);
      if ($this.is("input") || $this.is("textarea")) {
        $this.val("");
      }
    });
  },

  /**
   * Init form module
   */
  init() {
    const $defaultFocusField = $(".form-field--default-focus");
    if ($defaultFocusField.length) {
      $defaultFocusField.focus();
    }

    const $validationForm = $('form[data-use-validation="true"]');
    if ($validationForm.length) {
      const self = this;
      $validationForm.on("submit", function (event) {
        event.preventDefault();
        self.validate($(this));
      });

      $validationForm
        .find('[data-required="true"]')
        .on("keyup change", function () {
          if (!$validationForm.hasClass(self.FORM_DIRTY_CLASS)) {
            return;
          }
          const $field = $(this);
          if (!_.isEmpty($field.val())) {
            self.hideError($field);
          } else {
            self.showError($field);
          }
        });
    }
  },
};

export default form;
